"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePatientEndSection = void 0;
function makePatientEndSection(patients) {
    const data = [];
    for (const patient of patients) {
        data.push(makeEndSectionRow(patient));
    }
    return {
        title: 'End',
        subtitles: ['patient name'],
        type: 'end',
        data,
    };
}
exports.makePatientEndSection = makePatientEndSection;
function makeEndSectionRow(patient) {
    return {
        'Patient Surname': patient.lname,
    };
}
//# sourceMappingURL=patientEndSection.js.map